export var formatExpiry = function formatExpiry(input, prev) {
  if (prev == input) {
    input = input.slice(0, 1);
  }

  var sanitizedInput = input.replace(/[^\d]/g, '');

  if (sanitizedInput.length == 2) {
    if (input.endsWith('/')) {
      return sanitizedInput.slice(0, 2);
    } else {
      if (parseInt(sanitizedInput.slice(0, 2)) > 12) {
        return sanitizedInput;
      }

      return sanitizedInput;
    }
  }

  if (sanitizedInput.length > 2) {
    return sanitizedInput.slice(0, 2) + '/' + sanitizedInput.slice(2, 4);
  }

  return sanitizedInput;
};
export var validateExpiry = function validateExpiry() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
  return regex.test(value);
};